import { configureStore } from "@reduxjs/toolkit";
import notesReducer from "./notesSlice";
import articlesReducer from "./articlesSlice";
import fruitsReducer from "./fruitsSlice";
import usersDataReducer from "./usersDataSlice";
import usersReducer from "./usersSlice";
import photosReducer from "./photosSlice";
import themeReducer from "./themeSlice";
import botReducer from "./botSlice";

export const store = configureStore({
  reducer: {
    notes: notesReducer,
    articles: articlesReducer,
    fruits: fruitsReducer,
    usersData: usersDataReducer,
    users: usersReducer,
    photos: photosReducer,
    theme: themeReducer,
    bot: botReducer
  },
});
